import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//CSS
import "./itemInWarehousesView.css";

//Components
import Title from "../Other Components/Title";

//Functions and hooks
import { useTranslation } from "react-i18next";

export default function ItemInWarehousesView({
  WarehouseAmounts = [],
  totalItems,
  className,
}) {
  const navigate = useNavigate();
  useEffect(() => {}, [WarehouseAmounts]);

  const { t } = useTranslation();

  const navigateToWarehouse = useCallback(
    (id) => {
      navigate("/workspace/warehouses/warehouseEditPage", { state: { id } });
    },
    [navigate]
  );

  const createItems = (item, index) => {
    return (
      <div
        className="item-in-warehouses-item"
        key={index + "itemWarehouses"}
        onClick={() => navigateToWarehouse(item.WarehouseID)}
      >
        <span
          className="item-in-warehouse-warehouse "
          key={index + "itemWarehouses-warehouse"}
        >
          {item.Warehouse}
        </span>
        <span
          className="item-in-warehouse-amount"
          key={index + "itemWarehouses-warehouse"}
        >
          {item.Amount}
        </span>
      </div>
    );
  };

  return (
    <div
      className={
        "container-bordered item-in-warehouses-view" + " mt-3 " + className
      }
    >
      <Title>{t("Item across warehouses", { ns: "items" })}</Title>

      <div className="item-in-warehouses-header">
        <span className="item-in-warehouse-warehouse">{t("Warehouse")}</span>
        <span className="item-in-warehouse-amount">{t("Amount")}</span>
      </div>
      <div className="item-in-warehouses-items">
        {WarehouseAmounts.map(createItems)}
      </div>
      <div className="item-in-warehouses-total">
        <span className="item-in-warehouse-warehouse">
          {t("Total items", { ns: "items" }) + ":"}
        </span>
        <span className="item-in-warehouse-amount">{totalItems}</span>
      </div>
    </div>
  );
}
